/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const mediaSlider = document.querySelector('.media-slider');
const credentialsSlider = document.querySelector('.credentials-slider');

if( mediaSlider ) {
    var splide = new Splide( mediaSlider, {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: false,
        pagination: false,
        perPage: 10,
        perMove: 1,
        autoScroll: {
            speed: 1,
            pauseOnHover: false
        },
        breakpoints: {
            1440: {
                perPage: 6
            },
            1080: {
                perPage: 3
            },
            768: {
                perPage: 2,
                padding: {
                    right: '10%'
                },
            },
        }
    });
    splide.mount({ AutoScroll });
}

if( credentialsSlider ) {
    var splide2 = new Splide( credentialsSlider, {
        type: 'slider',
        rewind: true,
        speed: 1000,
        arrows: false,
        pagination: false,
        perPage: 3,
        perMove: 1,
        padding: {
            right: '6%'
        },
        breakpoints: {
            1080: {
                perPage: 1,
                padding: {
                    right: '10%'
                },
            },
        }
    });
    splide2.mount();
}